export default function(data) {
var __t, __p = '';
__p += '<a href="' +
((__t = ( this.discussionPath() + "#comments")) == null ? '' : __t) +
'" class="hover-target">\n  <i class="material-icons">chat_bubble</i>\n  <span class="icon-overlay comment-count">' +
((__t = ( this.model.commentCount() )) == null ? '' : __t) +
'</span>\n</a>\n';
return __p
}